import i18n from 'services/base/i18n';

export default {
  // The title for this page
  title: () => i18n.pgettext('Pages|Manage Pangolins', 'MANAGE PANGOLINS'),
  // A button to link a new pangolin to this account
  addPangolin: () => i18n.pgettext('Pages|Manage Pangolins', 'Add a Pangolin'),
};
